import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Radio, CheckCircle, ArrowRight } from 'lucide-react';

const RFID = () => {
  const features = [
    'Passive and active RFID tags',
    'Long-range reading capabilities',
    'Bulk scanning functionality',
    'Real-time asset visibility',
    'No line-of-sight required',
    'Durable tag options',
    'High-speed data capture',
    'Integration with existing systems',
    'Anti-collision technology',
    'Custom RFID solutions'
  ];

  return (
    <div className="min-h-screen bg-slate-50">
      <section className="bg-gradient-to-br from-slate-900 to-slate-800 text-white py-16 px-4">
        <div className="container mx-auto max-w-7xl">
          <div className="flex items-center justify-center mb-6">
            <Radio className="w-16 h-16 text-cyan-400" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center">RFID Technology</h1>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto text-center">
            Advanced RFID tracking for complete asset and inventory visibility
          </p>
        </div>
      </section>

      <section className="py-16 px-4">
        <div className="container mx-auto max-w-7xl">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">Next-Generation Tracking Technology</h2>
            <p className="text-lg text-slate-600">
              RFID (Radio-Frequency Identification) technology provides unparalleled accuracy and efficiency in tracking assets and inventory. Our RFID solutions enable contactless, automated data capture at scale, dramatically improving operational efficiency and accuracy.
            </p>
          </div>

          <div className="mb-16">
            <h3 className="text-2xl font-bold text-slate-900 mb-8 text-center">Key Features</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start space-x-3 bg-white p-4 rounded-lg shadow-sm">
                  <CheckCircle className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" />
                  <span className="text-slate-700">{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 px-4 bg-gradient-to-br from-cyan-600 to-blue-600 text-white">
        <div className="container mx-auto max-w-4xl text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Implement RFID Technology Today</h2>
          <p className="text-xl mb-8 text-cyan-100">
            Learn how RFID can revolutionize your tracking operations
          </p>
          <Link to="/contact">
            <Button size="lg" className="bg-white text-cyan-600 hover:bg-slate-100 px-8 py-6 text-lg transition-all duration-300 hover:scale-105">
              Get Started <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default RFID;